(function () {
  if (!window.location.pathname.includes('/products/')) return;

  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match && match[1] ? match[1] : '';
  if (!handle) return;

  var key = 'rv_products';
  var max = 20;
  var list;

  try {
    list = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(list)) list = [];
  } catch (e) {
    list = [];
  }

  // Already exists — no write needed
  if (list.indexOf(handle) !== -1) return;

  list.unshift(handle);
  // FIX 2: slice inline save karo, separate variable nahi
  localStorage.setItem(key, JSON.stringify(list.slice(0, max)));
})();